import { lifecycleStages } from "@/mocks/editorial";

const toneStyle: Record<string, { dot: string; pill: string }> = {
  quiet: { dot: "bg-secondary-500", pill: "bg-secondary-100 text-secondary-800" },
  hot: { dot: "bg-primary-500", pill: "bg-primary-100 text-primary-700" },
  wave: { dot: "bg-accent-500", pill: "bg-accent-100 text-accent-700" },
  calm: { dot: "bg-foreground-600", pill: "bg-foreground-800 text-background-50" },
};

export default function LifecycleSection() {
  return (
    <section id="lifecycle" className="scroll-mt-24 bg-background-50 py-12 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <p className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium tracking-wide text-secondary-800">
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-accent-500"></span>
            余波演变 · 热度生命周期
          </p>
          <h2 className="mt-4 font-heading text-2xl font-semibold leading-snug text-foreground-950 md:text-[2rem] md:leading-[1.3]">
            没有永远的热度，只有不同的余波
          </h2>
          <p className="mt-4 text-[15px] leading-relaxed text-foreground-600">
            一场震荡大致会走过四个阶段。所谓“后续影响”，往往藏在最后两段的静水流深里——热度退去时，才是尘埃落定的时候。
          </p>
        </div>

        <div className="relative mt-14 grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-4">
          {lifecycleStages.map((s, i) => {
            const tone = toneStyle[s.tone] ?? toneStyle.calm;
            return (
              <article
                key={s.name}
                className="relative rounded-2xl border border-background-200 bg-background-100/60 p-6 pt-7"
              >
                <div className="flex items-center justify-between">
                  <span className={`rounded-full px-3 py-1 text-xs font-medium ${tone.pill}`}>
                    {s.phase}
                  </span>
                  <span className="font-heading text-4xl font-semibold text-background-300">
                    0{i + 1}
                  </span>
                </div>
                <div className="mt-4 flex items-center gap-2">
                  <span className={`h-2.5 w-2.5 rounded-full ${tone.dot}`}></span>
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">
                    {s.name}
                  </h3>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                  {s.body}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}